// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate, updateStatusByContractList} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import UndoIcon from "@mui/icons-material/Undo";
import {changeContractStatsControls} from "../../WorkStats/contractStatsControlsSlice";


// main function
export default function UnapproveContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);


    const handleUnapprove = () => {
        onMenuClose();
        console.log("contractArray");
        console.log(contractArray);
        contractUpdate(contractArray, [], [],'Update Status',
            '2033', null, currentUserName, true)
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            })
            .finally(()=> {
                dispatchData(changeWorkQueue({actionMenuAction: null }));
                dispatchData(changeContractStatsControls({gridRefresh: true}));
                dispatchData(changeContractStatsControls({gridRefresh: true}));
            });

        ;
    };
    // const handleUnapprove = () => {
    //     onMenuClose();
    //     updateStatusByContractList(selectorContractList, 'Unapproved')
    //         .then(() => {
    //             dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
    //         });
    // };


    return (

        <Box>
            {(rowContractData.contractLevel === "Series" ||
                    rowContractData.contractLevel === "Season" ||
                    rowContractData.contractLevel === "Residuals" ||
                    rowContractData.contractLevel === "Participations" ||
                    rowContractData.contractLevel === "Royalties" ||
                    rowContractData.contractLevel === "Property" ||

                    rowContractData.contractLevel === "Labor Group" &&
                        (rowContractData.groupedStatus === "Approved" ||
                            rowContractData.groupedStatus === "Finalized")) &&
                <MenuItem onClick={handleUnapprove}>
                    <ListItemIcon>
                        <UndoIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unapprove</ListItemText>
                </MenuItem>}
        </Box>

    )

}
